import { useEffect, useState, useCallback } from "react";
import { errorAlert } from "../alert/defaultAlert";
import { useTranslation } from "react-i18next";
import Common from "../../../constants/Common";
import LoadingIcon from "../Icon/LoadingIcon";
import { Button } from "react-bootstrap";
import TrashIcon from "../Icon/TrashIcon";
import ImageCropperModal from "./ImageCropperModal";
import { useDropzone } from 'react-dropzone';
import "./ImagePreview.css";

const ImagePreview = (props) => {
    const { t } = useTranslation();
    const { permittedWidth, permittedHeight, permittedSize, setUploadedFile, uploadedFile, showLoading } = props;

    const [selectedImage, setSelectedImage] = useState(uploadedFile !== null ? uploadedFile : null);

    // Estados para o Cropper
    const [showCropper, setShowCropper] = useState(false);
    const [originalImageSrc, setOriginalImageSrc] = useState(null);

    // CallBack do Dropzone
    const onDrop = useCallback(acceptedFiles => {
        if (acceptedFiles && acceptedFiles.length > 0) {
            const file = acceptedFiles[0];

            // Validação de tipo já é feita pelo accept do dropzone, mas reforçamos
            if (!Common.IMAGE_VALID_TYPES.includes(file.type)) {
                errorAlert(t('message.only_image_file_allowed'));
                return;
            }

            // Lê o arquivo para URL para passar ao cropper
            const reader = new FileReader();
            reader.onload = (e) => {
                setOriginalImageSrc(e.target.result);
                setShowCropper(true);
            };
            reader.readAsDataURL(file);
        }
    }, [t]);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: {
            'image/jpeg': [],
            'image/png': [],
            'image/jpg': []
        },
        maxFiles: 1,
        multiple: false
    });

    const handleCropComplete = (croppedBlob) => {
        // Verifica tamanho do arquivo cortado
        if (croppedBlob.size > permittedSize) {
            errorAlert(t('message.generic_file_size_cannot_exceed', { size: permittedSize }));
            return;
        }

        // Cria URL para preview
        const previewUrl = URL.createObjectURL(croppedBlob);
        setSelectedImage(previewUrl);
        setUploadedFile(croppedBlob);
    };

    const onRemovePicure = () => {
        setUploadedFile(null);
        setOriginalImageSrc(null);
        // Revoke object url se necessário para evitar memory leak, mas o react lida com updates
    }

    useEffect(() => {
        if (!uploadedFile) {
            setSelectedImage(null);
        } else {
            if (uploadedFile instanceof Blob) {
                setSelectedImage(URL.createObjectURL(uploadedFile));
            } else {
                setSelectedImage(uploadedFile);
            }
        }
    }, [uploadedFile]);

    // Calcula aspect ratio
    const aspect = (permittedWidth && permittedHeight) ? (permittedWidth / permittedHeight) : 1;

    return (
        <div className="image-preview-wrapper">
            {/* Modal de Crop */}
            {originalImageSrc && (
                <ImageCropperModal
                    show={showCropper}
                    handleClose={() => setShowCropper(false)}
                    imageSrc={originalImageSrc}
                    onCropComplete={handleCropComplete}
                    aspect={aspect}
                    outputWidth={permittedWidth}
                    outputHeight={permittedHeight}
                />
            )}

            {
                (!showLoading) ?
                    (selectedImage ?
                        (
                            <div className="text-center">
                                <div className="preview-container mb-3">
                                    <img src={selectedImage} alt="Preview" className="img-fluid img-thumbnail preview-image" />
                                </div>
                                <div>
                                    <Button className="btn-sm" variant="danger" onClick={onRemovePicure}>
                                        <TrashIcon /> {t('remove_picture')}
                                    </Button>
                                    {/* Botão para trocar imagem sem remover explicitamente antes? O usuário pode clicar em remover. */}
                                </div>
                            </div>
                        ) : (
                            <div {...getRootProps()} className={`image-dropzone ${isDragActive ? 'active' : ''}`}>
                                <input {...getInputProps()} />
                                <div className="dropzone-icon">
                                    <i className="fa fa-cloud-upload-alt"></i>
                                </div>
                                <div className="dropzone-text">
                                    {isDragActive ? t('drop_image_here') : t('drag_and_drop_image')}
                                </div>
                                <div className="dropzone-hint">
                                    {t('or_click_to_select')}
                                </div>
                                {(permittedWidth && permittedHeight) && (
                                    <div className="dropzone-hint mt-1">
                                        ({permittedWidth}px x {permittedHeight}px)
                                    </div>
                                )}
                            </div>
                        )
                    )
                    :
                    <div className="text-center">
                        <div><LoadingIcon className="fa-6x mt-5" /></div>
                        <div className="mt-2">{t('loading_picture')}</div>
                    </div>
            }
        </div>
    );
}

export default ImagePreview;